import BoostPropertyStep from '../components/CheckoutSteps/BoostPropertyStep/BoostPropertyStep.vue';
import { useCheckoutStore } from '../stores/index';
import {
  CheckoutSchema,
  OrderItem,
  PurchaseBoostsPayload,
} from './../types/index';
import checkoutApi from './checkoutApi';
import { User } from '~/types/user';

const boostCheckoutSchema: CheckoutSchema = {
  title: 'Purchase Boosts',
  successMessage:
    'Congratulations. Your Boosts have been added to your account.',
  component: BoostPropertyStep,
  init: () => {},
  submit: async function (): Promise<void> {
    const store = useCheckoutStore();

    if (!store.hasOrderItems) {
      throw new Error('Cannot purchase boosts without selecting an item.');
    }

    const orderItem: OrderItem<Domain.Properties.DataObjects.BoostPriceData> =
      store.items[0];

    const quantity = orderItem.data?.quantity;
    if (!quantity) {
      throw new Error('Boost quantity cannot be null.');
    }

    const payload: PurchaseBoostsPayload =
      createPurchasePayload<PurchaseBoostsPayload>({
        quantity,
      });

    const { data, error } = await checkoutApi.boost.purchase(payload);

    if (data.value?.status === 'success') {
      const { user }: { user: User } = useAuth();
      user.boosts = data.value.quantity;

      await store.complete();
    }

    if (error.value?.data.status === 'failed') {
      store.loading = false;
      throw new Error(error.value.data.message);
    }
  },
};

export default boostCheckoutSchema;
